import { atom } from "jotai"

/**
 * Tracks whether the auth interceptors have been attached to the axios clients.
 * This is set to true in AppAuthGuard after authentication is resolved and
 * the Authorization header interceptors are configured.
 *
 * Query atoms should use this as an `enabled` flag to prevent API requests
 * from firing before auth is ready.
 */
export const isAuthReadyAtom = atom(false)

/**
 * Set to true when the API returns a 403 with reason "account_migrated",
 * indicating the user's legacy account was migrated and they should use
 * the new auth flow.
 */
export const isAccountMigratedAtom = atom(false)
